var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-cell',{attrs:{"format":_vm.format,"type":"stat","condensed":_vm.condensed}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }